<ng-container *ngIf="profileField$ | async as profileField">
    <dt [id]="profileField.FieldDefinition.FlatKey" class="sh-description-list__term" style="{{ nestedPadding$ | async }}">
        <sh-field-label [label]="profileField.DisplayLabel" [labelIcons]="labelIcons"></sh-field-label>
    </dt>

    <ng-container *ngIf="value$ | async as value; else emptyData">
        <dd class="sh-description-list__details sh-preserve-linebreaks -sh-overflow-scrolling">{{ value }}</dd>
    </ng-container>
</ng-container>

<ng-template #emptyData>
    <dd class="sh-description-list__details">-</dd>
</ng-template>
